import {
  USER_LOGIN_REQUEST,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_FAIL,
  GET_USER_CONVERSATION_START,
  GET_USER_CONVERSATION_FAIL,
  GET_USER_CONVERSATION_SUCCESS,
  SET_DISPLAY_CHAT,
  SET_SELECTED_CONVERSATION,
  SET_CONVERSATIONS,
  SET_DISPLAY_CUSTOMER_DETAILS,
  DELETE_CONVERSATION_START,
  DELETE_CONVERSATION_SUCCESS,
  DELETE_CONVERSATION_FAIL,
  LOGOUT_FAIL,
  LOGOUT_SUCCESS,
  LOGOUT_START,
  REGISTER_FAIL,
  REGISTER_START,
  REGISTER_SUCCESS,
  SET_CONSTANT_CONVERSATION,
  SET_SELECTED_USER_CUSTOMERS,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_START,
  UPDATE_USER_FAIL,
  SHOW_FILE_UPLOAD,
  SET_USER_VERIFICATION,
  PATCH_USER_START,
  PATCH_USER_SUCCESS,
  PATCH_USER_FAIL,
  UPDATE_CONVERSATIONS_SUCCESS,
  UPDATE_CONVERSATIONS_START,
  UPDATE_CONVERSATIONS_FAIL,
  MARK_CUSTOMER_MESSAGES_AS_READ,
  ARCHIVED_CONVERSATIONS_SUCCESS,
  ADD_CONVERSATION_SUCCESS,
  SELECTED_CONVERSATION_CHAT,
  UPDATE_GROUP_SELECTED_CONVERSATION_MEMBERS,
  UPDATE_CONVERSATION_MEDIA,
  UPDATE_CONVERSATION_DOCS,
  UPDATE_CONVERSATION_LINKS,
  GET_CONVERSATION_MEDIA_START,
  GET_CONVERSATION_MEDIA_FAIL,
  SET_MESSAGE_ID,
  SET_CONVERSATION_DATA,
} from "./constants";

import {
  getUserConversation,
  getUserConversationSuccess,
  getUserConversationError,
  setDisplayChat,
  setSelectedConversation,
  setConversations,
  setDisplayCustomerDetails,
  deleteConversationStart,
  deleteConversationSuccess,
  deleteConversationFail,
  logoutStart,
  logoutSuccess,
  logoutFail,
  registerStart,
  registerSuccess,
  registerFail,
  setSelectedUserCustomers,
  setConstantConversation,
  updateUserStart,
  updateUserFail,
  updateUserSuccess,
  showFileUploadFunction,
  setUserVerificationAction,
  patchUserStart,
  patchUserSuccess,
  patchUserFail,
  updateConversationSuccess,
  updateConversationStart,
  updateConversationFail,
  markCustomerMessagesAsRead,
  getArchivedConversationSuccess,
  addConversationSuccess,
  updateSelectedConversationMessages,
  updateSelectedConversationMembers,
  updateConversationMedia,
  updateConversationDocs,
  updateConversationLinks,
  getConversationMediaStart,
  getConversationMediaFail,
  setMessageId,
  setConversationData,
} from "./helper";

const initialState = {
  messageId: "",
  isUpdatingSelectedConversation: false,
  showFileUpload: false,
  isUserVerified: false,
  loading: false,
  conversations: [],
  archivedConversations: [],
  constantConversations: [],
  constantConversationsCopy: [],
  errorMsg: "",
  displayChat: false,
  selectedConversation: {
    media: [],
    chat: [],
  },
  displayCustomerDetails: true,
  selectedUserCustomer: [],
  // login
  userInfo: {},
  registerErrorMsg: "",
  updateUserErrorMsg: "",
  // patch user
  patchErrorMsg: "",
  getConversationMediaLoading: false,
  getConversationMediaError: "",
  canFetchMoreConversation: true,
  conversation: {},
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    // login
    case USER_LOGIN_REQUEST:
      return { ...initialState, loading: true };
    case USER_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        isLoggedIn: true,
        userInfo: { ...action.payload, isUserVerified: false },
      };
    case USER_LOGIN_FAIL:
      return { ...state, loading: false, errorMsg: action.payload };

    // register
    case REGISTER_START:
      return registerStart(state, action);
    case REGISTER_SUCCESS:
      return registerSuccess(state, action);
    case REGISTER_FAIL:
      return registerFail(state, action);

    // logout
    case LOGOUT_START:
      return logoutStart(state, action);
    case LOGOUT_SUCCESS:
      return logoutSuccess(state, action);
    case LOGOUT_FAIL:
      return logoutFail(state, action);

    // Update user
    case UPDATE_USER_START:
      return updateUserStart(state, action);
    case UPDATE_USER_SUCCESS:
      return updateUserSuccess(state, action);
    case UPDATE_USER_FAIL:
      return updateUserFail(state, action);

    // Patch user
    case PATCH_USER_START:
      return patchUserStart(state, action);
    case PATCH_USER_SUCCESS:
      return patchUserSuccess(state, action);
    case PATCH_USER_FAIL:
      return patchUserFail(state, action);

    // Get conversations
    case GET_USER_CONVERSATION_START:
      return getUserConversation(state);
    case GET_USER_CONVERSATION_SUCCESS:
      return getUserConversationSuccess(state, action);
    case GET_USER_CONVERSATION_FAIL:
      return getUserConversationError(state, action);

    // Get archived conversations
    case ARCHIVED_CONVERSATIONS_SUCCESS:
      return getArchivedConversationSuccess(state, action);

    // Delete conversation
    case DELETE_CONVERSATION_START:
      return deleteConversationStart(state, action);
    case DELETE_CONVERSATION_SUCCESS:
      return deleteConversationSuccess(state, action);
    case DELETE_CONVERSATION_FAIL:
      return deleteConversationFail(state, action);

    // Update Conversation
    case UPDATE_CONVERSATIONS_START:
      return updateConversationStart(state, action);
    case UPDATE_CONVERSATIONS_SUCCESS:
      return updateConversationSuccess(state, action);
    case UPDATE_CONVERSATIONS_FAIL:
      return updateConversationFail(state, action);

    // Mark customer messages as read
    case MARK_CUSTOMER_MESSAGES_AS_READ: {
      return markCustomerMessagesAsRead(state, action);
    }

    // Add conversation
    case ADD_CONVERSATION_SUCCESS: {
      return addConversationSuccess(state, action);
    }

    // Update selected conversation messages
    case SELECTED_CONVERSATION_CHAT:
      return updateSelectedConversationMessages(state, action);

    // Update selected conversation members
    case UPDATE_GROUP_SELECTED_CONVERSATION_MEMBERS:
      return updateSelectedConversationMembers(state, action);

    // Update conversation media/links/docs
    case UPDATE_CONVERSATION_MEDIA:
      return updateConversationMedia(state, action);
    case UPDATE_CONVERSATION_DOCS:
      return updateConversationDocs(state, action);
    case UPDATE_CONVERSATION_LINKS:
      return updateConversationLinks(state, action);

    // Get conversation media
    case GET_CONVERSATION_MEDIA_START:
      return getConversationMediaStart(state, action);
    case GET_CONVERSATION_MEDIA_FAIL:
      return getConversationMediaFail(state, action);

    case SET_DISPLAY_CHAT:
      return setDisplayChat(state, action);
    case SET_SELECTED_CONVERSATION:
      return setSelectedConversation(state, action);
    case SET_CONVERSATIONS:
      return setConversations(state, action);
    case SET_DISPLAY_CUSTOMER_DETAILS:
      return setDisplayCustomerDetails(state, action);

    case SET_SELECTED_USER_CUSTOMERS:
      return setSelectedUserCustomers(state, action);
    case SET_CONSTANT_CONVERSATION:
      return setConstantConversation(state, action);
    case SHOW_FILE_UPLOAD:
      return showFileUploadFunction(state, action);
    case SET_USER_VERIFICATION:
      return setUserVerificationAction(state, action);

    // Set message id to stop adding messages whe scroll in not at bottom
    case SET_MESSAGE_ID:
      return setMessageId(state, action);

    case SET_CONVERSATION_DATA:
      return setConversationData(state, action);

    default:
      return state;
  }
};

export default usersReducer;
